import React from 'react'
import { useTheme } from '../../utils/useTheme'

export const AlertErrorIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref): React.ReactElement => {
    const theme = useTheme()
    return (
      <svg
        width="16"
        height="16"
        viewBox="4 4 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M3.99866 10.6892C3.99866 6.99366 6.99452 3.9978 10.6901 3.9978H13.3086C17.0041 3.9978 20 6.99366 20 10.6892V13.3077C20 17.0033 17.0041 19.9991 13.3086 19.9991H10.6901C6.99451 19.9991 3.99866 17.0033 3.99866 13.3077V10.6892Z"
          fill={theme.tokens.background.semantic.error.main.default}
        />
        <path
          d="M13.7921 10.2066L10.208 13.7907"
          stroke={theme.tokens.foreground.main.staticWhite}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.7915 13.7907L10.2075 10.2066"
          stroke={theme.tokens.foreground.main.staticWhite}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
)

export default AlertErrorIcon
